<template>
  <div v-if="innerShow" ref="contextMenu" class="context-menu-content disable-select"
    :style="{top:innerPosition.y+'px',left:innerPosition.x+'px'}" v-click-outside="closeMenu">
    <ul @click.stop="onEventActions">
      <!-- 分别传递事件给父元素调用 -->
      <template v-if="menuType === 'file'">
        <li v-if="!disabled.uploadAndCreate">
          <a href="javascript:;" data-action="uploadFile">
            <span class="align-middle">{{$t('core.upload_files')}}</span>
          </a>
        </li>
        <li v-if="!disabled.uploadAndCreate">
          <a href="javascript:;" data-action="uploadFolder">
            <span class="align-middle">{{$t('core.upload_folder')}}</span>
          </a>
        </li>
        <li v-if="!disabled.uploadAndCreate">
          <a href="javascript:;" data-action="createFile">
            <span class="align-middle">{{$t('core.create_file')}}</span>
          </a>
        </li>
        <li v-if="!disabled.uploadAndCreate">
          <a href="javascript:;" data-action="createFolder">
            <span class="align-middle">{{$t('core.create_folder')}}</span>
          </a>
        </li>
        <!-- 预览 -->
        <li v-if="!disabled.preview">
          <a href="javascript:;" data-action="preview">
            <span class="cos-icon--16 mr-4 preview" v-if="showIcon"></span>
            <span class="align-middle">{{disabled.previewType==='image'?$t('core.preview'):$t('core.play')}}</span>
          </a>
        </li>
        <li v-if="!disabled.edit">
          <a href="javascript:;" data-action="edit">
            <span class="cos-icon--16 mr-4 edit" v-if="showIcon"></span>
            <span class="align-middle">{{$t('core.edit')}}</span>
          </a>
        </li>
        <li v-if="!disabled.detail">
          <a href="javascript:;" data-action="detail">
            <span class="cos-icon--16 mr-4 detail" v-if="showIcon"></span>
            <span class="align-middle">{{$t('core.detail')}}</span>
          </a>
        </li>
        <li v-if="!disabled.share">
          <a href="javascript:;" data-action="share">
            <span class="cos-icon--16 mr-4 share" v-if="showIcon"></span>
            <span class="align-middle">{{$t('core.share')}}</span>
          </a>
        </li>
        <li v-if="!disabled.download">
          <a href="javascript:;" data-action="download">
            <span class="cos-icon--16 mr-4 download" v-if="showIcon"></span>
            <span class="align-middle">{{$t('core.download')}}</span>
          </a>
        </li>
        <li v-if="!disabled.rename">
          <a href="javascript:;" data-action="rename">
            <span class="cos-icon--16 mr-4 rename" v-if="showIcon"></span>
            <span class="align-middle">{{$t('core.rename')}}</span>
          </a>
        </li>
        <li v-if="!disabled.copy">
          <a href="javascript:;" data-action="copy">
            <span class="cos-icon--16 mr-4 copy" v-if="showIcon"></span>
            <span class="align-middle">{{$t('core.copy')}}</span>
          </a>
        </li>
        <li>
          <a href="javascript:;" data-action="paste" :class="{'disabled': disabled.paste}">
            <span class="cos-icon--16 mr-4 copy" v-if="showIcon"></span>
            <span class="align-middle">{{$t('core.paste')}}</span>
          </a>
        </li>
        <li>
          <a href="javascript:;" data-action="delete">
            <span class="cos-icon--16 mr-4 delete" v-if="showIcon"></span>
            <span class="align-middle">{{$t('core.delete')}}</span>
          </a>
        </li>
        <li>
          <a href="javascript:;" data-action="createFile">
            <span class="align-middle">{{$t('core.create_file')}}</span>
          </a>
        </li>
        <li>
          <a href="javascript:;" data-action="createFolder">
            <span class="align-middle">{{$t('core.create_folder')}}</span>
          </a>
        </li>
      </template>
      <template v-if="menuType === 'bucket'">
        <li v-if="!disabled.bucketInfo">
          <a href="javascript:;" data-action="bucketInfo">
            <span class="align-middle">{{$t('cos.bucket_detail')}}</span>
          </a>
        </li>
        <hr v-if="!disabled.bucketInfo" class="mt-5 mb-5">
        <li>
          <a href="javascript:;" data-action="uploadFile">
            <span class="align-middle">{{$t('core.upload_files')}}</span>
          </a>
        </li>
        <li>
          <a href="javascript:;" data-action="uploadFolder">
            <span class="align-middle">{{$t('core.upload_folder')}}</span>
          </a>
        </li>
        <li>
          <a href="javascript:;" data-action="createFile">
            <span class="align-middle">{{$t('core.create_file')}}</span>
          </a>
        </li>
        <li>
          <a href="javascript:;" data-action="createFolder">
            <span class="align-middle">{{$t('core.create_folder')}}</span>
          </a>
        </li>
        <li>
          <a href="javascript:;" data-action="refresh">
            <span class="align-middle">{{$t('core.refresh')}}</span>
          </a>
        </li>
        <li>
          <a href="javascript:;" data-action="paste" :class="{'disabled': disabled.paste}">
            <span class="align-middle">{{$t('core.paste')}}</span>
          </a>
        </li>
      </template>

    </ul>
  </div>
</template>

<script>
import { getInnerProps } from '@/scripts/tools/utils';
import eventProxy from '@/scripts/tools/eventProxy';

export default {
  name: 'contextMenu',
  props: {
    show: {
      type: [Boolean],
      default: false,
    },
    menuType: {
      type: String,
      default: 'file',
    },
    position: {
      type: Object,
      default: () => ({ x: 0, y: 0 }),
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      innerPosition: { x: 0, y: 0 },
      disabled: {
        preview: false,
        edit: false,
        detail: false,
        share: false,
        rename: false,
        copy: false,
        paste: false,
      },
    };
  },
  computed: {
    innerShow: getInnerProps('show'),
  },
  watch: {
    position(val) {
      if (val) {
        this.handlePosition();
      }
    },
  },
  mounted() {
    eventProxy.on('context-menu-option', this.handleOptions);
    eventProxy.on('close-context-menu', this.closeMenu);
  },
  destroyed() {
    eventProxy.off('context-menu-option', this.handleOptions);
    eventProxy.off('close-context-menu', this.closeMenu);
  },
  methods: {
    handlePosition() {
      const contextMenuItems = this.menuType === 'file'
        ? [
          'preview',
          'edit',
          'detail',
          'share',
          'download',
          'rename',
          'copy',
          'paste',
          'delete',
        ]
        : [
          'bucketInfo',
          'uploadFile',
          'uploadFolder',
          'createFile',
          'createFolder',
          'refresh',
          'paste',
        ];
      let total = contextMenuItems.length;
      Object.keys(this.disabled).forEach(key => {
        const isDisabled = this.disabled[key];
        if (key === 'paste') return; // 粘贴只禁用不隐藏
        if (isDisabled && contextMenuItems.includes(key)) {
          total--;
        }
      });
      if (!this.disabled.uploadAndCreate) {
        total += 4;
      }
      const contextMenuHeight = 30 * total; // 右键菜单真实高度
      const headersHeight = 97; // logo + 导航头部的高度

      let y = this.position.y - headersHeight;
      const contentHeader = document.body.clientHeight - headersHeight;
      if (y + contextMenuHeight >= contentHeader) {
        y -= contextMenuHeight;
        if (!this.disabled.bucketInfo && this.menuType !== 'file') {
          y -= 11; // 去掉隔断线高度
        }
      }

      this.innerPosition = { x: this.position.x + 2, y };
    },
    onEventActions(e) {
      let { target } = e;
      if (target.dataset && !target.dataset.action) {
        target = target.parentNode;
      }
      const { action } = target.dataset;
      if (action === 'paste' && this.disabled.paste) return;

      if (action) {
        this.$emit('on-action', action);
        this.closeMenu();
      }
    },
    handleOptions(options) {
      this.disabled = { ...this.disabled, ...options };
    },
    closeMenu() {
      this.innerShow = false;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
